import { render, staticRenderFns } from "./HomeTasks.vue?vue&type=template&id=0e8ccd20&scoped=true&"
import script from "./HomeTasks.vue?vue&type=script&lang=js&"
export * from "./HomeTasks.vue?vue&type=script&lang=js&"
import style0 from "./HomeTasks.vue?vue&type=style&index=0&id=0e8ccd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8ccd20",
  null
  
)

export default component.exports